var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAutomationActionRemove(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "moon icon-new tag-x",
    width: 6,
    height: 6,
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      display: "inline-block",
      verticalAlign: "middle"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M25.205 25.205c33.606-33.606 88.093-33.606 121.698 0l365.151 365.15 365.151-365.15c33.606-33.606 88.092-33.606 121.698 0s33.606 88.093 0 121.698l-365.151 365.151 365.043 365.043c33.606 33.606 33.606 88.092 0 121.698s-88.092 33.606-121.698 0l-365.043-365.043-365.043 365.043c-33.606 33.606-88.092 33.606-121.698 0s-33.606-88.092 0-121.698l365.042-365.043-365.15-365.151c-33.606-33.606-33.606-88.092-0-121.698z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomationActionRemove);
export default __webpack_public_path__ + "static/media/AutomationActionRemove.a1cde37bfee852b548110d01e61f4d41.svg";
export { ForwardRef as ReactComponent };